import { render } from "./SupportDetail.vue?vue&type=template&id=e7009808"
import script from "./SupportDetail.vue?vue&type=script&lang=js"
export * from "./SupportDetail.vue?vue&type=script&lang=js"

import "./SupportDetail.vue?vue&type=style&index=0&id=e7009808&lang=scss"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__